import React from 'react';

const IconFilters = () => {
	return (
		<svg aria-hidden="true" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
			<mask id="mask0_1063_4316" style={{ maskType: 'alpha' }} maskUnits="userSpaceOnUse" x="0" y="0" width="16" height="16">
				<rect width="16" height="16" fill="#D9D9D9"/>
			</mask>
			<g mask="url(#mask0_1063_4316)">
				<path d="M7.76689 13.4333V9.76669H8.63353V11.1667H13.4335V12.0333H8.63353V13.4333H7.76689ZM2.56689 12.0333V11.1667H6.23353V12.0333H2.56689ZM4.96689 9.83332V8.43332H2.56689V7.56668H4.96689V6.16668H5.83353V9.83332H4.96689ZM7.36689 8.43332V7.56668H13.4335V8.43332H7.36689ZM9.76689 6.23332V2.56668H10.6335V3.96668H13.4335V4.83332H10.6335V6.23332H9.76689ZM2.56689 4.83332V3.96668H8.63353V4.83332H2.56689Z" fill="#545454"/>
			</g>
		</svg>
	);
};

export default IconFilters;
